import React from "react";
import BaseButton from "./BaseButton";
import { ToTopOutlined } from '@ant-design/icons';

const BaseImport = (props) =>
  <BaseButton className={ "import-button" } { ...props } ><ToTopOutlined className="import-button-icon" />Import</BaseButton>

export default BaseImport;
